import {h, Component} from 'preact'
import {connect} from 'react-redux'
import reduce from '../reducers'
import * as actions from '../actions'
import store from '../store'
import Renderer from '../canvas/renderer'
import { deleteFramePreview } from '../canvas/reposition-frame'

export default @connect(reduce, actions)
class FramePreviewBar extends Component {
  constructor() {
    super();

    this.onDone = () => {
        Renderer.deselectAll();
        store.dispatch(actions.deselect());
        deleteFramePreview();
    }

    this.onCancel = () => {
        const $element = this.props.$element;
        if (!$element) return;
        let $frame = null;
        $element.parent().find('[data-component="frame"]').each(function() {
            if ($(this).attr('id') === $element.attr('id')) {
                $frame = $(this);
            }
        })
        let newBgCss = $element.attr('data-bgcss-cancel');
        $frame.find('.img').css('background', newBgCss);
        this.onDone();
    }
  }
  
  render(props, state) {
    return (
      <div className="context-bar">
        <ul className="two-column-layout">
            <li>
                <div className="dropdown sizes">
                    <a className="dropdown-toggle car stacked" data-hint="Done" onClick={() => this.onDone()}>
                        {props.isMobileVersion && <i className="fa fa-check fa-2x"></i>}
                        <span>Done</span>
                    </a>
                </div>
            </li>
            <li>
                <div className="dropdown sizes">
                    <a className="dropdown-toggle car stacked" data-hint="Cancel" onClick={() => this.onCancel()}>
                        {props.isMobileVersion && <i className="fa fa-times fa-2x"></i>}
                        <span>Cancel</span>
                    </a>
                </div>
            </li>
        </ul>
      </div>
    )
  }
}
